import React from "react";
import { Grid } from "@scuf/common";
import KPIStat from "../../components/common/KPIStat/KPIStat";
import ProgressDiario from "../Diario/Progress-Diario";

import "../Diario/Diario.css";

export default function Diario() {
  return (
    <>
      <Grid className="m-0 p-0">
        <Grid.Row>
          <Grid.Column
            xsWidth="12"
            sWidth="12"
            mWidth="12"
            lWidth="12"
            xlWidth="12"
          >
            {" "}
            <Grid.Row>
              <Grid.Column
                xsWidth="12"
                sWidth="2"
                mWidth="2"
                lWidth="2"
                xlWidth="2"
              >
                <ProgressDiario body="020105" site="Chuquicamata" />
              </Grid.Column>

              <Grid.Column
                xsWidth="12"
                sWidth="2"
                mWidth="2"
                lWidth="2"
                xlWidth="2"
              >
                <ProgressDiario body="020105" site="Chuquicamata" />
              </Grid.Column>

              <Grid.Column
                xsWidth="12"
                sWidth="2"
                mWidth="2"
                lWidth="2"
                xlWidth="2"
              >
                <ProgressDiario body="020107" site="DMH" />
              </Grid.Column>

              <Grid.Column
                xsWidth="12"
                sWidth="2"
                mWidth="2"
                lWidth="2"
                xlWidth="2"
              >
                <ProgressDiario body="020104" site="Salvador" />
              </Grid.Column>

              <Grid.Column
                xsWidth="12"
                sWidth="2"
                mWidth="2"
                lWidth="2"
                xlWidth="2"
              >
                <ProgressDiario body="020105" site="Andina" />
              </Grid.Column>

              <Grid.Column
                xsWidth="12"
                sWidth="2"
                mWidth="2"
                lWidth="2"
                xlWidth="2"
              >
                <ProgressDiario body="020106" site="Teniente" />
              </Grid.Column>
            </Grid.Row>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
}
